import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { AuthService } from '../../services/auth.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';

@Component({
  selector: 'app-callback',
  standalone: true,
  imports: [RouterLink, MatButtonModule, SpinnerComponent],
  templateUrl: './callback.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './callback.component.scss',
})
export class CallbackComponent implements OnInit {
  error = '';
  constructor(
    private readonly authService: AuthService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    void this.initialize();
  }

  async initialize(): Promise<void> {
    if (this.route.snapshot.queryParamMap.has('error')) {
      this.error = 'Sign-in was not completed. Please try again.';
      return;
    }
    try {
      const user = await this.authService.initializeSession();
      if (!user) {
        this.error = 'Unable to complete sign-in. Please try again.';
        return;
      }
      await this.router.navigate(['/dashboard'], { replaceUrl: true });
    } catch {
      this.error = 'Unable to complete sign-in. Please try again.';
    }
  }
}
